var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    fill: "#33aeff",
    opacity: 1,
    "data-original": "#33aeff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M103 26.62a2.34 2.34 0 0 1-2.3 2.38H59.3a2.38 2.38 0 0 1 0-4.75h.7a5.43 5.43 0 0 1 0-.57 8.26 8.26 0 0 1 7.14-8.3A10.61 10.61 0 0 1 77.52 5a10.06 10.06 0 0 1 4 .84 10.73 10.73 0 0 1 6 7.15 7.66 7.66 0 0 1 3.2-.69 8.21 8.21 0 0 1 8.07 8.35 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.38 2.37z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M103 26.62a2.34 2.34 0 0 1-2.3 2.38H78.37c5.83 0 8.39-2.1 8.45-5.63A3.87 3.87 0 0 0 84.94 20a1 1 0 0 1-.31-1.35C88 12.42 81.55 5.84 81.55 5.84a10.73 10.73 0 0 1 6 7.15 7.66 7.66 0 0 1 3.2-.69 7.89 7.89 0 0 1 6 2.76 8.49 8.49 0 0 1 2.08 5.59 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.34 2.37z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M103 26.62a2.34 2.34 0 0 1-2.3 2.38H88.77a5.46 5.46 0 0 0 3.77-4.83 1 1 0 0 1 .83-.85c1.72-.23 5.53-1.49 3.42-8.26a8.49 8.49 0 0 1 2.08 5.59 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.3 2.37z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M100.7 30H59.3a3.38 3.38 0 0 1-.3-6.74 9.25 9.25 0 0 1 7.19-8.73 11.37 11.37 0 0 1 22.09-2.85 8.88 8.88 0 0 1 2.57-.38 9.22 9.22 0 0 1 9.06 9.35 9.82 9.82 0 0 1-.35 2.6h1.18a3.38 3.38 0 0 1 0 6.75zm-41.4-4.75a1.38 1.38 0 0 0 0 2.75h41.4a1.35 1.35 0 0 0 1.3-1.38 1.33 1.33 0 0 0-1.3-1.37h-2.61a1 1 0 0 1-.85-.47 1 1 0 0 1-.06-1 7.55 7.55 0 0 0 .69-3.18 7.22 7.22 0 0 0-7.06-7.35 6.78 6.78 0 0 0-2.8.6 1 1 0 0 1-.84 0 1 1 0 0 1-.54-.65 9.4 9.4 0 0 0-18.54 2.18 1 1 0 0 1-.88 1 7.24 7.24 0 0 0-6.21 7.3v.5a1 1 0 0 1-1 1.07z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M71.72 12.67a1 1 0 0 1-.27-1.39A7.35 7.35 0 0 1 77.52 8a1 1 0 0 1 0 2 5.37 5.37 0 0 0-4.42 2.4 1 1 0 0 1-1.38.27z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M50 58.62A2.34 2.34 0 0 1 47.7 61H6.3a2.38 2.38 0 0 1 0-4.75H7a5.43 5.43 0 0 1 0-.57 8.26 8.26 0 0 1 7.14-8.3A10.61 10.61 0 0 1 24.52 37a10.06 10.06 0 0 1 4 .84A10.73 10.73 0 0 1 34.6 45a7.66 7.66 0 0 1 3.2-.69 8.21 8.21 0 0 1 8.07 8.35 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.3 2.36z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M50 58.62A2.34 2.34 0 0 1 47.7 61H25.37c5.83 0 8.39-2.1 8.45-5.63A3.87 3.87 0 0 0 31.94 52a1 1 0 0 1-.31-1.35c3.41-6.19-3.08-12.77-3.08-12.77A10.73 10.73 0 0 1 34.6 45a7.66 7.66 0 0 1 3.2-.69 7.89 7.89 0 0 1 6 2.76 8.49 8.49 0 0 1 2.08 5.59 8.61 8.61 0 0 1-.78 3.6h2.6a2.34 2.34 0 0 1 2.3 2.36z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M50 58.62A2.34 2.34 0 0 1 47.7 61H35.77a5.46 5.46 0 0 0 3.77-4.83 1 1 0 0 1 .83-.85c1.72-.23 5.53-1.49 3.42-8.26a8.49 8.49 0 0 1 2.08 5.59 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.3 2.37z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M47.7 62H6.3a3.38 3.38 0 0 1-.3-6.74 9.25 9.25 0 0 1 7.19-8.73 11.37 11.37 0 0 1 22.09-2.85 8.88 8.88 0 0 1 2.57-.38 9.22 9.22 0 0 1 9.06 9.35 9.82 9.82 0 0 1-.35 2.6h1.14a3.38 3.38 0 0 1 0 6.75zM6.3 57.25a1.38 1.38 0 0 0 0 2.75h41.4a1.35 1.35 0 0 0 1.3-1.38 1.33 1.33 0 0 0-1.3-1.37h-2.61a1 1 0 0 1-.85-.47 1 1 0 0 1-.06-1 7.55 7.55 0 0 0 .69-3.18 7.22 7.22 0 0 0-7.06-7.35 6.78 6.78 0 0 0-2.8.6 1 1 0 0 1-.84 0 1 1 0 0 1-.54-.65 9.53 9.53 0 0 0-9.11-7.2 9.58 9.58 0 0 0-9.43 9.42 1 1 0 0 1-.88 1A7.24 7.24 0 0 0 8 55.68v.5a1 1 0 0 1-1 1.07z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M19.27 44.84a.94.94 0 0 1-.55-.17 1 1 0 0 1-.27-1.39A7.35 7.35 0 0 1 24.52 40a1 1 0 0 1 0 2 5.37 5.37 0 0 0-4.42 2.4 1 1 0 0 1-.83.44z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M124 68.62a2.34 2.34 0 0 1-2.3 2.38H80.3a2.38 2.38 0 0 1 0-4.75h.7a5.43 5.43 0 0 1 0-.57 8.26 8.26 0 0 1 7.14-8.3A10.61 10.61 0 0 1 98.52 47a10.06 10.06 0 0 1 4 .84 10.73 10.73 0 0 1 6 7.15 7.66 7.66 0 0 1 3.2-.69 8.21 8.21 0 0 1 8.07 8.35 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.38 2.37z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M124 68.62a2.34 2.34 0 0 1-2.3 2.38H99.37c5.83 0 8.39-2.1 8.45-5.63a3.87 3.87 0 0 0-1.88-3.37 1 1 0 0 1-.31-1.35c3.41-6.19-3.08-12.77-3.08-12.77a10.73 10.73 0 0 1 6 7.15 7.66 7.66 0 0 1 3.2-.69 7.89 7.89 0 0 1 6 2.76 8.49 8.49 0 0 1 2.08 5.59 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.34 2.33z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M124 68.62a2.34 2.34 0 0 1-2.3 2.38h-11.93a5.46 5.46 0 0 0 3.77-4.83 1 1 0 0 1 .83-.85c1.72-.23 5.53-1.49 3.42-8.26a8.49 8.49 0 0 1 2.08 5.59 8.61 8.61 0 0 1-.78 3.6h2.61a2.34 2.34 0 0 1 2.3 2.37z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M121.7 72H80.3a3.38 3.38 0 0 1-.3-6.74 9.25 9.25 0 0 1 7.19-8.73 11.37 11.37 0 0 1 22.09-2.85 8.88 8.88 0 0 1 2.57-.38 9.22 9.22 0 0 1 9.06 9.35 9.82 9.82 0 0 1-.35 2.6h1.18a3.34 3.34 0 0 1 3.3 3.37A3.39 3.39 0 0 1 124 71a3.24 3.24 0 0 1-2.3 1zm-41.4-4.75a1.38 1.38 0 0 0 0 2.75h41.4a1.35 1.35 0 0 0 1.3-1.38 1.33 1.33 0 0 0-1.3-1.37h-2.61a1 1 0 0 1-.85-.47 1 1 0 0 1-.06-1 7.55 7.55 0 0 0 .69-3.18 7.22 7.22 0 0 0-7.06-7.35 6.78 6.78 0 0 0-2.8.6 1 1 0 0 1-.84 0 1 1 0 0 1-.54-.65 9.4 9.4 0 0 0-18.54 2.18 1 1 0 0 1-.88 1 7.24 7.24 0 0 0-6.21 7.3v.5a1 1 0 0 1-1 1.07z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M92.72 54.67a1 1 0 0 1-.27-1.39A7.35 7.35 0 0 1 98.52 50a1 1 0 0 1 0 2 5.37 5.37 0 0 0-4.42 2.4 1 1 0 0 1-1.38.27z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 48h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 38,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 21,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 90,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#8597a1",
    d: "M38 33h6v4h-6z",
    opacity: 1,
    "data-original": "#8597a1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M44 38h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-5-2h4v-2h-4z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M44 124a1 1 0 0 1-1-1V21a1 1 0 0 1 2 0v102a1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 35,
    r: 12,
    fill: "#90a4ae",
    opacity: 1,
    "data-original": "#90a4ae",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 35,
    r: 8,
    fill: "#ffdc7b",
    opacity: 1,
    "data-original": "#ffdc7b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 35,
    r: 5,
    fill: "#fff9e6",
    opacity: 1,
    "data-original": "#fff9e6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M118 123H86a4 4 0 0 1-3.68-5.61l11.91-28.55A9.9 9.9 0 0 0 95 85V69h14v16a9.9 9.9 0 0 0 .77 3.84l11.88 28.55A4 4 0 0 1 118 123z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m86.35 117.39 11.88-28.55A9.9 9.9 0 0 0 99 85V69h-4v16a9.9 9.9 0 0 1-.77 3.84l-11.88 28.55A4 4 0 0 0 86 123h4a4 4 0 0 1-3.65-5.61z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "m121.65 117.39-11.88-28.55A9.9 9.9 0 0 1 109 85V69h-6v16a9.9 9.9 0 0 0 .77 3.84l11.88 28.55A4 4 0 0 1 112 123h6a4 4 0 0 0 3.65-5.61z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc7b",
    d: "M118 123H86a4 4 0 0 1-3.68-5.61L91.67 95h20.66l9.32 22.39A4 4 0 0 1 118 123z",
    opacity: 1,
    "data-original": "#ffdc7b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb260",
    d: "M121.65 117.39 112.33 95h-6l9.32 22.39A4 4 0 0 1 112 123h6a4 4 0 0 0 3.65-5.61z",
    opacity: 1,
    "data-original": "#ffb260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff9e6",
    d: "M86.35 117.39 95.67 95h-4l-9.32 22.39A4 4 0 0 0 86 123h4a4 4 0 0 1-3.65-5.61z",
    opacity: 1,
    "data-original": "#fff9e6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M64 124a1 1 0 0 1-1-1V95a1 1 0 0 1 2 0v28a1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M59 119h10a2 2 0 0 1 2 2v2H57v-2a2 2 0 0 1 2-2z",
    opacity: 1,
    "data-original": "#90a4ae",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8597a1",
    d: "M65 119h4a2 2 0 0 1 2 2v2h-6v-4z",
    opacity: 1,
    "data-original": "#8597a1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2c6d1",
    d: "M59 119h2v4h-4v-2a2 2 0 0 1 2-2z",
    opacity: 1,
    "data-original": "#b2c6d1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb242",
    d: "M68 115c0 4-4 4-4 4s-4 0-4-4c0-3 4-7 4-7s4 4 4 7z",
    opacity: 1,
    "data-original": "#ffb242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdfb0",
    d: "M64 108v11s-4 0-4-4c0-3 4-7 4-7z",
    opacity: 1,
    "data-original": "#ffdfb0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M71 54V35H57v19a25 25 0 1 0 14 0z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M71 54V35h-6v21a25 25 0 0 1 3.86 46.52A25 25 0 0 0 71 54z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M43 80a25 25 0 0 1 18-24V35h-4v19a25 25 0 0 0-2.14 47.27A25 25 0 0 1 43 80z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5948",
    d: "M89 78a25 25 0 1 1-46.35-13h42.7A24.76 24.76 0 0 1 89 78z",
    opacity: 1,
    "data-original": "#ff5948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e84b3a",
    d: "M85.35 65H78a25 25 0 0 1-9.13 37.52A25 25 0 0 0 85.35 65z",
    opacity: 1,
    "data-original": "#e84b3a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc8c2",
    d: "M43 80a24.89 24.89 0 0 1 5-15h-5.35a25 25 0 0 0 12.22 36.27A25 25 0 0 1 43 80z",
    opacity: 1,
    "data-original": "#ffc8c2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 6,
    x: 54,
    y: 29,
    fill: "#e9f2ff",
    rx: 3,
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M68 29h3a3 3 0 0 1 3 3 3 3 0 0 1-3 3h-3v-6z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M57 29h1v6h-1a3 3 0 0 1-3-3 3 3 0 0 1 3-3z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M64 104a26 26 0 0 1-8-50.74V35a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18.26A26 26 0 0 1 64 104zm-6-68v18a1 1 0 0 1-.72 1 24 24 0 1 0 13.44 0 1 1 0 0 1-.72-1V36z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M71 36H57a4 4 0 0 1 0-8h14a4 4 0 0 1 0 8zm-14-6a2 2 0 0 0 0 4h14a2 2 0 0 0 0-4z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 6,
    x: 92,
    y: 63,
    fill: "#e9f2ff",
    rx: 3,
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M106 63h3a3 3 0 0 1 3 3 3 3 0 0 1-3 3h-3v-6z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M95 63h1v6h-1a3 3 0 0 1-3-3 3 3 0 0 1 3-3z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M109 70H95a4 4 0 0 1 0-8h14a4 4 0 0 1 0 8zm-14-6a2 2 0 0 0 0 4h14a2 2 0 0 0 0-4z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 6,
    x: 11,
    y: 61,
    fill: "#e9f2ff",
    rx: 3,
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M25 61h3a3 3 0 0 1 3 3 3 3 0 0 1-3 3h-3v-6z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M14 61h1v6h-1a3 3 0 0 1-3-3 3 3 0 0 1 3-3z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M28 68H14a4 4 0 0 1 0-8h14a4 4 0 0 1 0 8zm-14-6a2 2 0 0 0 0 4h14a2 2 0 0 0 0-4zM64 104a26 26 0 0 1-26-26 25.75 25.75 0 0 1 3.8-13.52 1 1 0 0 1 .85-.48h42.7a1 1 0 0 1 .85.48A25.75 25.75 0 0 1 90 78a26 26 0 0 1-26 26zM43.22 66a24 24 0 1 0 41.56 0z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 65,
    r: 4,
    fill: "#ffc8c2",
    opacity: 1,
    "data-original": "#ffc8c2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M67 70a5 5 0 1 1 5-5 5 5 0 0 1-5 5zm0-8a3 3 0 1 0 3 3 3 3 0 0 0-3-3z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 75,
    r: 3,
    fill: "#ffc8c2",
    opacity: 1,
    "data-original": "#ffc8c2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M54 79a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 85,
    r: 3,
    fill: "#ffc8c2",
    opacity: 1,
    "data-original": "#ffc8c2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M63 89a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM89 96H39a1 1 0 0 1 0-2h50a1 1 0 0 1 0 2z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M36 124h-.21a1 1 0 0 1-.77-1.19l6-28a1 1 0 0 1 2 .42l-6 28A1 1 0 0 1 36 124zM92 124a1 1 0 0 1-1-.79l-6-28a1 1 0 0 1 .79-1.21 1 1 0 0 1 1.19.77l6 28a1 1 0 0 1-.77 1.19zM71 124H57a1 1 0 0 1-1-1v-2a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1zm-13-2h12v-1a1 1 0 0 0-1-1H59a1 1 0 0 0-1 1z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M64 120a4.82 4.82 0 0 1-5-5c0-3.32 3.85-7.27 4.29-7.71a1 1 0 0 1 1.42 0c.44.44 4.29 4.39 4.29 7.71a4.82 4.82 0 0 1-5 5zm0-10.53c-1.22 1.39-3 3.8-3 5.53a3 3 0 1 0 6 0c0-1.73-1.78-4.14-3-5.53zM124 124H80a1 1 0 0 1 0-2h44a1 1 0 0 1 0 2zM75 124H4a1 1 0 0 1 0-2h71a1 1 0 0 1 0 2z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M14 67h14v49a7 7 0 0 1-7 7 7 7 0 0 1-7-7V67z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M18 116V67h-4v49a7 7 0 0 0 7 7 7.27 7.27 0 0 0 2-.29 7 7 0 0 1-5-6.71z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "M23 67v49a7 7 0 0 1-4.5 6.53A7 7 0 0 0 28 116V67z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M21 124a8 8 0 0 1-8-8V67a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v49a8 8 0 0 1-8 8zm-6-56v48a6 6 0 0 0 12 0V68z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31ddf4",
    d: "M28 89v27a7 7 0 0 1-14 0V89z",
    opacity: 1,
    "data-original": "#31ddf4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36c8e3",
    d: "M23 89v27a7 7 0 0 1-4.5 6.53A7 7 0 0 0 28 116V89z",
    opacity: 1,
    "data-original": "#36c8e3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adf4ff",
    d: "M18 116V89h-4v27a7 7 0 0 0 7 7 6.91 6.91 0 0 0 2-.29 7 7 0 0 1-5-6.71z",
    opacity: 1,
    "data-original": "#adf4ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#353166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 124a8 8 0 0 1-8-8V89a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v27a8 8 0 0 1-8 8zm-6-34v26a6 6 0 0 0 12 0V90zM20 74h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 78h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 82h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 86h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z",
    fill: "#353166",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 90h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 94h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 98h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 102h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 106h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM20 110h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM118 124H86a5 5 0 0 1-4.23-2.29 5 5 0 0 1-.36-4.73l11.9-28.52A8.9 8.9 0 0 0 94 85V69a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a8.9 8.9 0 0 0 .69 3.46L122.57 117a4.92 4.92 0 0 1-.37 4.7 5 5 0 0 1-4.2 2.3zM96 70v15a11 11 0 0 1-.84 4.23l-11.89 28.54a3 3 0 0 0 .21 2.85A3 3 0 0 0 86 122h32a3 3 0 0 0 2.55-1.38 2.92 2.92 0 0 0 .22-2.82l-11.9-28.57A11 11 0 0 1 108 85V70z",
    fill: "#353166",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 124H86a5 5 0 0 1-4.23-2.29 5 5 0 0 1-.36-4.73l9.31-22.36a1 1 0 0 1 .92-.62h20.66a1 1 0 0 1 .92.62l9.35 22.38a4.92 4.92 0 0 1-.37 4.7 5 5 0 0 1-4.2 2.3zM92.34 96l-9.07 21.77a3 3 0 0 0 .21 2.85A3 3 0 0 0 86 122h32a3 3 0 0 0 2.55-1.38 2.92 2.92 0 0 0 .22-2.82L111.66 96zM102 75h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM102 79h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM102 83h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM102 87h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z",
    fill: "#353166",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e9f2ff",
    d: "M90.05 26.81 107 43.73a17.12 17.12 0 0 1 2.5 3.27 16.07 16.07 0 0 0 2.5 3.14 2 2 0 0 1 0 2.86 2 2 0 0 1-2.83 0 16.07 16.07 0 0 0-3.17-2.47h-.05a17.12 17.12 0 0 1-3.22-2.53L85.81 31.05z",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M85.81 31.05 102.73 48a17.12 17.12 0 0 0 3.27 2.5h.05a16.07 16.07 0 0 1 3.09 2.5 2 2 0 0 0 2.86 0L88 29z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 81.51,
    y: 25.51,
    fill: "#e9f2ff",
    rx: 2,
    transform: "rotate(-45 86.51 27.535)",
    opacity: 1,
    "data-original": "#e9f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b9d7ff",
    d: "m85.088 26.115 2.12-2.121a2 2 0 0 1 2.829 0 2 2 0 0 1 0 2.828l-2.121 2.12-2.828-2.827z",
    opacity: 1,
    "data-original": "#b9d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5948",
    d: "M81.88 18.69a3.1 3.1 0 0 1 1 1.19 11.79 11.79 0 0 0 2.22 3.38l1.42 1.43-2.82 2.82-1.2-1.19A10 10 0 0 0 79.1 24a2.81 2.81 0 0 1-1.1-.73 3 3 0 0 1 .44-4.61 3 3 0 0 1 3.44.03z",
    opacity: 1,
    "data-original": "#ff5948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M110.56 54.56a3 3 0 0 1-2.12-.88 16 16 0 0 0-2.94-2.3 17.15 17.15 0 0 1-3.47-2.7L85.1 31.76a1 1 0 0 1 0-1.42l4.24-4.24a1 1 0 0 1 1.42 0L107.68 43a17.25 17.25 0 0 1 2.67 3.41 15.43 15.43 0 0 0 2.33 3 3 3 0 0 1-2.12 5.13zM87.22 31.05l16.22 16.22a15.77 15.77 0 0 0 3 2.37 17.23 17.23 0 0 1 3.38 2.62 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 17.75 17.75 0 0 1-2.59-3.32 15.66 15.66 0 0 0-2.4-3.09L90.05 28.22z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M84.39 32.64a3 3 0 0 1-2.12-5.13l4.24-4.24a3.09 3.09 0 0 1 4.25 0 3 3 0 0 1 0 4.24l-4.25 4.25a3 3 0 0 1-2.12.88zm4.25-8.25a1 1 0 0 0-.71.3l-4.24 4.24a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l4.24-4.24a1 1 0 0 0-.7-1.71z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M83.69 28.51a1 1 0 0 1-.71-.29L81.79 27a8.69 8.69 0 0 0-3-2.13 4 4 0 0 1-2.58-4.11 4 4 0 0 1 6.29-2.91 4.15 4.15 0 0 1 1.32 1.57 10.77 10.77 0 0 0 2 3.11l1.4 1.47a1 1 0 0 1 0 1.41l-2.83 2.83a1 1 0 0 1-.7.27zm-3.54-9.36a1.91 1.91 0 0 0-1.11.34 2 2 0 0 0-.88 1.51 1.94 1.94 0 0 0 .58 1.59 1.88 1.88 0 0 0 .71.47 10.37 10.37 0 0 1 3.75 2.59l.49.48 1.41-1.41-.72-.72A12.63 12.63 0 0 1 82 20.3a2.16 2.16 0 0 0-.68-.8 2 2 0 0 0-1.17-.35zM27 48a13 13 0 1 1 13-13 13 13 0 0 1-13 13zm0-24a11 11 0 1 0 11 11 11 11 0 0 0-11-11z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353166",
    d: "M27 44a9 9 0 1 1 9-9 9 9 0 0 1-9 9zm0-16a7 7 0 1 0 7 7 7 7 0 0 0-7-7z",
    opacity: 1,
    "data-original": "#353166",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.8ded0ca1a9149f6362c6649062fcc751.svg";
export { ForwardRef as ReactComponent };